import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  return (
    <Container>
      <Box sx={{ mt: 8, mb: 12 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h2"
            component="h1"
            align="center"
            className="gradient-text"
            sx={{ mb: 4 }}
          >
            Hakkımızda
          </Typography>
          <Typography
            variant="body1"
            align="center"
            color="text.secondary"
            sx={{ mb: 6, maxWidth: '800px', mx: 'auto' }}
          >
            Rose Tarot, modern teknolojiyi ve geleneksel tarot okumalarını bir araya getiren
            yenilikçi bir platformdur. Amacımız, size kişiselleştirilmiş ve anlamlı tarot
            okumaları sunarak, hayatınızdaki önemli kararları almanızda rehberlik etmektir.
          </Typography>
        </motion.div>
      </Box>
    </Container>
  );
};

export default About; 